//测试组件
import { Sucu01Data0030001Component } from './datablock/storelistblock/sucu01-data0030001/sucu01-data0030001.component';
import { TableFormInputComponent } from './components/tableformblock/table-form-input/table-form-input.component';

import { Sucu05Button0010001Component } from './buttonblock/generalbtnblock/sucu05-button0010001/sucu05-button0010001.component';
import { Sucu05Button0010002Component } from './buttonblock/generalbtnblock/sucu05-button0010002/sucu05-button0010002.component';
import { Sucu05Button0010003Component } from './buttonblock/generalbtnblock/sucu05-button0010003/sucu05-button0010003.component';
import { Sucu05Button0010004Component } from './buttonblock/generalbtnblock/sucu05-button0010004/sucu05-button0010004.component';
import { Sucu05Button0010005Component } from './buttonblock/generalbtnblock/sucu05-button0010005/sucu05-button0010005.component';
import { Sucu05Button0010006Component } from './buttonblock/generalbtnblock/sucu05-button0010006/sucu05-button0010006.component';
import { Sucu05Button0010007Component } from './buttonblock/generalbtnblock/sucu05-button0010007/sucu05-button0010007.component';
import { Sucu05Button0010008Component } from './buttonblock/generalbtnblock/sucu05-button0010008/sucu05-button0010008.component';
import { Sucu05Button0020001Component } from './buttonblock/servicebtnblock/sucu05-button0020001/sucu05-button0020001.component';
import { Sucu05Button0020002Component } from './buttonblock/servicebtnblock/sucu05-button0020002/sucu05-button0020002.component';
import { Sucu05Button0020003Component } from './buttonblock/servicebtnblock/sucu05-button0020003/sucu05-button0020003.component';
import { Sucu05Button0020004Component } from './buttonblock/servicebtnblock/sucu05-button0020004/sucu05-button0020004.component';
import { Sucu05Button0020005Component } from './buttonblock/servicebtnblock/sucu05-button0020005/sucu05-button0020005.component';
import { Sucu05Button0030001Component } from './buttonblock/diybtnblock/sucu05-button0030001/sucu05-button0030001.component';
import { Sucu05Button0030002Component } from './buttonblock/diybtnblock/sucu05-button0030002/sucu05-button0030002.component';
import { Sucu01Data0010001Component } from './datablock/tableblock/sucu01-data0010001/sucu01-data0010001.component';
import { Sucu01Data0010002Component } from './datablock/tableblock/sucu01-data0010002/sucu01-data0010002.component';
import { Sucu01Data0020001Component } from './datablock/tablepicblock/sucu01-data0020001/sucu01-data0020001.component';
import { Sucu02Form0010001Component } from './formblock/baseformblock/sucu02-form0010001/sucu02-form0010001.component';
// import { Sucu03Charts0010001Component } from './chartsblock/barcharts/sucu03-charts0010001/sucu03-charts0010001.component';
// import { Sucu03Charts0010002Component } from './chartsblock/barcharts/sucu03-charts0010002/sucu03-charts0010002.component';
// import { Sucu03Charts0010003Component } from './chartsblock/barcharts/sucu03-charts0010003/sucu03-charts0010003.component';
// import { Sucu03Charts0020001Component } from './chartsblock/piecharts/sucu03-charts0020001/sucu03-charts0020001.component';
// import { Sucu03Charts0020002Component } from './chartsblock/piecharts/sucu03-charts0020002/sucu03-charts0020002.component';
// import { Sucu03Charts0030001Component } from './chartsblock/linecharts/sucu03-charts0030001/sucu03-charts0030001.component';
// import { Sucu03Charts0030002Component } from './chartsblock/linecharts/sucu03-charts0030002/sucu03-charts0030002.component';
// import { Sucu03Charts0030003Component } from './chartsblock/linecharts/sucu03-charts0030003/sucu03-charts0030003.component';
// import { Sucu03Charts0030004Component } from './chartsblock/linecharts/sucu03-charts0030004/sucu03-charts0030004.component';
// import { Sucu03Charts0040001Component } from './chartsblock/relationshipcharts/sucu03-charts0040001/sucu03-charts0040001.component';
// import { Sucu03Charts0040002Component } from './chartsblock/relationshipcharts/sucu03-charts0040002/sucu03-charts0040002.component';
// import { Sucu03Charts0050001Component } from './chartsblock/gaugecharts/sucu03-charts0050001/sucu03-charts0050001.component';
import { Sucu04Weiget0010001Component } from './controlblock/inputblock/sucu04-weiget0010001/sucu04-weiget0010001.component';
import { Sucu04Weiget0010002Component } from './controlblock/inputblock/sucu04-weiget0010002/sucu04-weiget0010002.component';
import { Sucu04Weiget0010003Component } from './controlblock/inputblock/sucu04-weiget0010003/sucu04-weiget0010003.component';
import { Sucu04Weiget0010004Component } from './controlblock/inputblock/sucu04-weiget0010004/sucu04-weiget0010004.component';
import { Sucu04Weiget0010005Component } from './controlblock/inputblock/sucu04-weiget0010005/sucu04-weiget0010005.component';
import { Sucu04Weiget0010006Component } from './controlblock/inputblock/sucu04-weiget0010006/sucu04-weiget0010006.component';
import { Sucu04Weiget0020001Component } from './controlblock/selectblock/sucu04-weiget0020001/sucu04-weiget0020001.component';
import { Sucu04Weiget0020002Component } from './controlblock/selectblock/sucu04-weiget0020002/sucu04-weiget0020002.component';
import { Sucu04Weiget0020003Component } from './controlblock/selectblock/sucu04-weiget0020003/sucu04-weiget0020003.component';
import { Sucu04Weiget0030001Component } from './controlblock/enclosureblock/sucu04-weiget0030001/sucu04-weiget0030001.component';
import { Sucu04Weiget0030002Component } from './controlblock/enclosureblock/sucu04-weiget0030002/sucu04-weiget0030002.component';
import { Sucu04Weiget0030003Component } from './controlblock/enclosureblock/sucu04-weiget0030003/sucu04-weiget0030003.component';
import { Sucu04Weiget0030004Component } from './controlblock/enclosureblock/sucu04-weiget0030004/sucu04-weiget0030004.component';
import { Sucu04Weiget0030005Component } from './controlblock/enclosureblock/sucu04-weiget0030005/sucu04-weiget0030005.component';
import { Sucu04Weiget0030006Component } from './controlblock/enclosureblock/sucu04-weiget0030006/sucu04-weiget0030006.component';
import { Sucu04Weiget0030007Component } from './controlblock/enclosureblock/sucu04-weiget0030007/sucu04-weiget0030007.component';
import { Sucu04Weiget0040001Component } from './controlblock/datetimeblock/sucu04-weiget0040001/sucu04-weiget0040001.component';
import { Sucu04Weiget0040002Component } from './controlblock/datetimeblock/sucu04-weiget0040002/sucu04-weiget0040002.component';
import { Sucu04Weiget0040003Component } from './controlblock/datetimeblock/sucu04-weiget0040003/sucu04-weiget0040003.component';
import { Sucu04Weiget0040004Component } from './controlblock/datetimeblock/sucu04-weiget0040004/sucu04-weiget0040004.component';
import { Sucu04Weiget0050001Component } from './controlblock/calculateblock/sucu04-weiget0050001/sucu04-weiget0050001.component';
import { Sucu04Weiget0050002Component } from './controlblock/calculateblock/sucu04-weiget0050002/sucu04-weiget0050002.component';
import { Sucu04Weiget0060001Component } from './controlblock/mapsblock/sucu04-weiget0060001/sucu04-weiget0060001.component';
import { Sucu04Weiget0060002Component } from './controlblock/mapsblock/sucu04-weiget0060002/sucu04-weiget0060002.component';
import { Sucu04Weiget0070001Component } from './controlblock/textblock/sucu04-weiget0070001/sucu04-weiget0070001.component';
import { Sucu04Weiget0080001Component } from './controlblock/richtext/sucu04-weiget0080001/sucu04-weiget0080001.component';
import { Sucu06Element0010001Component } from './elementblock/textblock/sucu06-element0010001/sucu06-element0010001.component';
import { Sucu06Element0010002Component } from './elementblock/textblock/sucu06-element0010002/sucu06-element0010002.component';
import { Sucu06Element0010003Component } from './elementblock/textblock/sucu06-element0010003/sucu06-element0010003.component';
import { Sucu06Element0030001Component } from './elementblock/widgetblock/sucu06-element0030001/sucu06-element0030001.component';
import { Sucu06Element0030002Component } from './elementblock/widgetblock/sucu06-element0030002/sucu06-element0030002.component';
import { Sucu06Element0020001Component } from './elementblock/iconblock/sucu06-element0020001/sucu06-element0020001.component';
import { Sucu05Button0010009Component } from './buttonblock/generalbtnblock/sucu05-button0010009/sucu05-button0010009.component';

import { Sucu04Weiget0090001Component } from './controlblock/radio/sucu04-weiget0090001/sucu04-weiget0090001.component';
import { Sucu04Weiget0100001Component } from './controlblock/checkbox/sucu04-weiget0100001/sucu04-weiget0100001.component';
import { Sucu04Weiget0080002Component } from './controlblock/richtext/sucu04-weiget0080002/sucu04-weiget0080002.component';
import { Sucu04Weiget0020004Component } from './controlblock/selectblock/sucu04-weiget0020004/sucu04-weiget0020004.component';

import { TableFormSelectComponent } from './components/tableformblock/table-form-select/table-form-select.component';
import { TableFormNumberComponent } from './components/tableformblock/table-form-number/table-form-number.component';

import { Sucu04Weiget0020005Component } from './controlblock/selectblock/sucu04-weiget0020005/sucu04-weiget0020005.component';
import { Sucu01Data0010003Component } from './datablock/tableblock/sucu01-data0010003/sucu01-data0010003.component';
import { AutoTestComponent } from './components/auto-test/auto-test.component';

const blockComps=[
    AutoTestComponent,
    Sucu01Data0010003Component,
    Sucu04Weiget0020005Component,
    TableFormNumberComponent,
    Sucu04Weiget0090001Component,
    Sucu04Weiget0100001Component,
    Sucu05Button0010001Component,
    Sucu05Button0010002Component,
    Sucu05Button0010003Component,
    Sucu05Button0010004Component,
    Sucu05Button0010005Component,
    Sucu05Button0010006Component,
    Sucu05Button0010007Component,
    Sucu05Button0010009Component,
    Sucu05Button0020001Component,
    Sucu05Button0020002Component,
    Sucu05Button0020003Component,
    Sucu05Button0020004Component,
    Sucu05Button0020005Component,
    Sucu05Button0030001Component,
    Sucu05Button0030002Component,
    Sucu01Data0010001Component,
    Sucu01Data0010002Component,
    Sucu01Data0020001Component,
    Sucu02Form0010001Component,
        // Sucu03Charts0010001Component,
        // Sucu03Charts0010002Component,
        // Sucu03Charts0010003Component,
        // Sucu03Charts0020001Component,
        // Sucu03Charts0020002Component,
        // Sucu03Charts0030001Component,
        // Sucu03Charts0030002Component,
        // Sucu03Charts0030003Component,
        // Sucu03Charts0030004Component,
        // Sucu03Charts0040001Component,
        // Sucu03Charts0040002Component,
        // Sucu03Charts0050001Component,
        Sucu04Weiget0010001Component,
        Sucu04Weiget0010002Component,
        Sucu04Weiget0010003Component,
        Sucu04Weiget0010004Component,
        Sucu04Weiget0010005Component,
        Sucu04Weiget0010006Component,
        Sucu04Weiget0020001Component,
        Sucu04Weiget0020002Component,
        Sucu04Weiget0020003Component,
        Sucu04Weiget0030001Component,
        Sucu04Weiget0030002Component,
        Sucu04Weiget0030003Component,
        Sucu04Weiget0030004Component,
        Sucu04Weiget0030005Component,
        Sucu04Weiget0030006Component,
        Sucu04Weiget0030007Component,
        Sucu04Weiget0040001Component,
        Sucu04Weiget0040002Component,
        Sucu04Weiget0040003Component,
        Sucu04Weiget0040004Component,
        Sucu04Weiget0050001Component,
        Sucu04Weiget0050002Component,
        Sucu04Weiget0060001Component,
        Sucu04Weiget0060002Component,
        Sucu04Weiget0070001Component,
        Sucu04Weiget0080001Component,
        Sucu06Element0010001Component,
        Sucu06Element0010002Component,
        Sucu06Element0010003Component,
        Sucu06Element0020001Component,
        Sucu06Element0030001Component,
        Sucu06Element0030002Component,
        Sucu05Button0010008Component,
        Sucu04Weiget0080002Component,
        Sucu04Weiget0020004Component,
        Sucu01Data0030001Component,
        TableFormInputComponent,
        TableFormSelectComponent
]

const blockJson={
    Sucu01Data0010003Component,
    Sucu04Weiget0020005Component,
    Sucu04Weiget0090001Component,
    Sucu04Weiget0100001Component,
    Sucu05Button0010001Component,
    Sucu05Button0010002Component,
    Sucu05Button0010003Component,
    Sucu05Button0010004Component,
    Sucu05Button0010005Component,
    Sucu05Button0010006Component,
    Sucu05Button0010007Component,
    Sucu05Button0010009Component,
    Sucu05Button0020001Component,
    Sucu05Button0020002Component,
    Sucu05Button0020003Component,
    Sucu05Button0020004Component,
    Sucu05Button0020005Component,
    Sucu05Button0030001Component,
    Sucu05Button0030002Component,
    Sucu01Data0010001Component,
    Sucu01Data0010002Component,
    Sucu01Data0020001Component,
    Sucu02Form0010001Component,
        // Sucu03Charts0010001Component,
        // Sucu03Charts0010002Component,
        // Sucu03Charts0010003Component,
        // Sucu03Charts0020001Component,
        // Sucu03Charts0020002Component,
        // Sucu03Charts0030001Component,
        // Sucu03Charts0030002Component,
        // Sucu03Charts0030003Component,
        // Sucu03Charts0030004Component,
        // Sucu03Charts0040001Component,
        // Sucu03Charts0040002Component,
        // Sucu03Charts0050001Component,
        Sucu04Weiget0010001Component,
        Sucu04Weiget0010002Component,
        Sucu04Weiget0010003Component,
        Sucu04Weiget0010004Component,
        Sucu04Weiget0010005Component,
        Sucu04Weiget0010006Component,
        Sucu04Weiget0020001Component,
        Sucu04Weiget0020002Component,
        Sucu04Weiget0020003Component,
        Sucu04Weiget0030001Component,
        Sucu04Weiget0030002Component,
        Sucu04Weiget0030003Component,
        Sucu04Weiget0030004Component,
        Sucu04Weiget0030005Component,
        Sucu04Weiget0030006Component,
        Sucu04Weiget0030007Component,
        Sucu04Weiget0040001Component,
        Sucu04Weiget0040002Component,
        Sucu04Weiget0040003Component,
        Sucu04Weiget0040004Component,
        Sucu04Weiget0050001Component,
        Sucu04Weiget0050002Component,
        Sucu04Weiget0060001Component,
        Sucu04Weiget0060002Component,
        Sucu04Weiget0070001Component,
        Sucu04Weiget0080001Component,
        Sucu06Element0010001Component,
        Sucu06Element0010002Component,
        Sucu06Element0010003Component,
        Sucu06Element0020001Component,
        Sucu06Element0030001Component,
        Sucu06Element0030002Component,
        Sucu05Button0010008Component,
        Sucu04Weiget0080002Component,
        Sucu04Weiget0020004Component,
        Sucu01Data0030001Component
}
export {blockComps,blockJson}